<div class="iq-title-box iq-title-default {{ titleSectionProp.class }}">
    <div *ngIf="titleSectionProp.titleIcon" class="iq-title-icon"></div>
    <span class="iq-subtitle" *ngIf="titleSectionProp.subTitle">{{ titleSectionProp.subTitle }}</span>
    <h2 class="iq-title {{ titleSectionProp.titleClass }}" *ngIf="titleSectionProp.title">{{ titleSectionProp.title }}</h2>
    <p class="iq-title-desc {{ titleSectionProp.descClass }}" *ngIf="titleSectionProp.description">{{ titleSectionProp.description }}</p>
</div>

  